import React from 'react';
import { useTranslation } from 'react-i18next';

export default function AuthVisual({ className = '' }) {
  const { t } = useTranslation();

  return (
    <div className={`auth-visual ${className}`.trim()}>
      <img
        src={require('../img/auth_quantum_integrada.webp')}
        srcSet={`${require('../img/auth_quantum_integrada-640.webp')} 640w, ${require('../img/auth_quantum_integrada-1280.webp')} 1280w, ${require('../img/auth_quantum_integrada.webp')} 1712w`}
        sizes="(max-width: 760px) 100vw, 55vw"
        width="1712"
        height="919"
        decoding="async"
        alt={t('authVisualAlt')}
        className="auth-illustration"
      />
    </div>
  );
}
